<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    scroll="keep"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <form @submit.prevent="passes(exportReport)">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Choose Date</p>
          </header>
          <section class="modal-card-body">
            <BaseDatePicker
              v-model="criteria.date"
              label="Date"
              :rules="'required'"
            >
            </BaseDatePicker>
          </section>
          <footer class="modal-card-foot" style="display: block">
            <button class="button" type="button" @click="closeModal">
              Cancel
            </button>
            <button
              class="button is-primary"
              :loading="loading"
              @click.prevent="passes(exportReport)"
            >
              Export
            </button>
          </footer>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker'
import ScheduleApi from '@/api/schedules'

export default {
  name: 'ExportPlayoutScheduleModal',
  components: {
    BaseDatePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channelId: {
      type: Number,
      default: null,
    },
    date: {
      type: Date,
      default: null,
    },
    channelName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      initialized: false,
      showModal: this.show,
      criteria: {
        date: this.date || new Date(),
      },
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    },
  },
  async created() {
    this.initialized = true
  },
  methods: {
    async exportReport() {
      try {
        this.loading = false
        await ScheduleApi.exportPlayout(
          this.channelId,
          this.criteria.date,
          this.channelName
        )
        this.closeModal()
      } catch (err) {
        console.log(err)
        this.$buefy.toast.open({
          message: 'Error exporting schedule',
          position: 'is-top',
          type: 'is-danger',
        })
        this.loading = false
      }
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },
  },
}
</script>
